import { render } from "./OrganizationTable.vue?vue&type=template&id=0f15b1ea&scoped=true"
import script from "./OrganizationTable.vue?vue&type=script&lang=js"
export * from "./OrganizationTable.vue?vue&type=script&lang=js"

import "./OrganizationTable.vue?vue&type=style&index=0&id=0f15b1ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f15b1ea"],['__file',"src/views/UserManagement/OrganizationManagement/components/OrganizationListComponents/OrganizationTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f15b1ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f15b1ea', __exports__)) {
    api.reload('0f15b1ea', __exports__)
  }
  
  module.hot.accept("./OrganizationTable.vue?vue&type=template&id=0f15b1ea&scoped=true", () => {
    api.rerender('0f15b1ea', render)
  })

}


export default __exports__